(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GenderController', GenderController);

    GenderController.$inject = ['$scope', '$state', 'Gender', 'GenderSearch'];

    function GenderController ($scope, $state, Gender, GenderSearch) {
        var vm = this;
        
        vm.genders = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Gender.query(function(result) {
                vm.genders = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            GenderSearch.query({query: vm.searchQuery}, function(result) {
                vm.genders = result;
            });
        }    }
})();
